import { RadioTheme, styles, variants } from '../RadioStyles.css';
import { baseTheme } from './RadioBaseTheme.css';
import { multiVariantStyles } from './RadioVariants.css';

/*******************
 * Component Theme
 *******************/

const RadioRedwoodTheme: RadioTheme = {
  baseTheme,
  multiVariantStyles,
  variants,
  styles
};

/*******************
 * Exports
 *******************/

export { RadioRedwoodTheme };
